export default __webpack_public_path__ + "static/media/cover-card-expert-360.8de2d3a9.svg";